export default "__VITE_ASSET__3caad25c__"